import { render } from "./AuthContainer.vue?vue&type=template&id=0a9718e2&scoped=true"
import script from "./AuthContainer.vue?vue&type=script&lang=js"
export * from "./AuthContainer.vue?vue&type=script&lang=js"

import "./AuthContainer.vue?vue&type=style&index=0&id=0a9718e2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9718e2"]])

export default __exports__